module.exports = __webpack_public_path__ + "assets/img/Group8449.9aa1580b.png";